import Base from './base';
import { IOrderRequest } from '../../interfaces/models/order';

export default {
  create: async (data: IOrderRequest): Promise<any> => (await Base()).post('/orders/checkout', data),
  getList: async (): Promise<any> => (await Base()).get('/orders/user'),
  getByReceiptId: async (receiptId: string): Promise<any> => (await Base()).get(`/orders/user/${receiptId}`),
  cancel: async (receiptId: string): Promise<any> => (await Base()).delete(`/orders/${receiptId}/cancel`),
};
